const my_offers_tab = {
  my_available_offers: 'Mes offres disponibles ({{offers}})',
  offer_details: "Détails de l'offre",
  to_access: 'Accéder',
}


export default my_offers_tab
